import { FormConfig } from '@frontend/design-system';
import { multiSelect, textareaField } from '../../../utils/field-config-helpers';

export const patientBillingConfig = {
  paymentTypes: multiSelect(),
  billingRelated: textareaField(),
  newPatientConsultationBilling: textareaField(),
  costOfCleaning: textareaField(),
} satisfies FormConfig;

export type PatientBillingConfigType = typeof patientBillingConfig;
